/**
 * Component: Scroll to Content
 * Description: 
 *
 * Usage:
 *   - Automatically initialises on page load.
 *
 * Notes:
 * 
 */

export function scrollToNextSection(elem) {
    if (!elem || !elem.length) return;

    function smoothScrollTo(targetY, duration) {
        const startY = window.scrollY;
        const distance = targetY - startY;
        let startTime = null;

        function animationStep(timestamp) {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);

            const ease =
                progress < 0.5
                    ? 2 * progress * progress
                    : 1 - Math.pow(-2 * progress + 2, 2) / 2;

            window.scrollTo(0, startY + distance * ease);

            if (progress < 1) {
                requestAnimationFrame(animationStep);
            }
        }

        requestAnimationFrame(animationStep);
    }

    function scroller(duration = 1200) {
        const sections = Array.from(document.querySelectorAll('.section-flow'));
        const header = document.querySelector('.site-header');
        const headerOffset = header ? header.offsetHeight : 0;

        const scrollPosition = window.scrollY + window.innerHeight / 2;

        const currentIndex = sections.findIndex(section => {
            const top = section.offsetTop;
            const bottom = top + section.offsetHeight;
            return scrollPosition >= top && scrollPosition < bottom;
        });

        const nextSection = sections[currentIndex + 1];

        if (nextSection) {
            const targetY = nextSection.offsetTop - headerOffset;
            smoothScrollTo(targetY, duration);
        }
    }

    elem.forEach(btn => {
        btn.addEventListener('click', () => scroller());
    });
}